import { IconProps } from '../../types/IconProps';

export const ChevronUp = ({ variant, className }: IconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    fill='none'
    className={`${className || ''}`}>
    <path
      fill={variant === 'light' ? '#fff' : '#0B223E'}
      d='M21.062 16.73a.846.846 0 0 1-1.197 0L12 8.867 4.136 16.73a.847.847 0 1 1-1.198-1.198l8.464-8.463a.846.846 0 0 1 1.197 0l8.463 8.463a.846.846 0 0 1 0 1.198Z'
    />
  </svg>
);
